/** Formats a numeric amount as the shop's currency (defaults to INR). Display only — the server is authoritative for order totals. */
export function formatMoney(amount: number, currency = 'INR'): string {
  try {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency }).format(amount)
  } catch {
    return `${currency} ${amount.toFixed(2)}`
  }
}

/** Formats catch-weight kilograms (D-099) — trims trailing zeros, groups thousands: `1,250.5 kg`. */
export function formatKg(kg: number): string {
  return `${(+kg.toFixed(3)).toLocaleString('en-IN')} kg`
}
